(() => {
  const init = () => {
    const forms = document.querySelectorAll('form[action^="/cart/add"]');
    if (!forms.length) return;

    forms.forEach((form) => {
      const addBtn =
        form.querySelector('button[name="add"]') ||
        form.querySelector('.product-form__submit');

      const idInput = form.querySelector('input[name="id"], select[name="id"]');
      if (!addBtn || !idInput) return;

      const setState = () => {
        const value = (idInput.value || "").trim();
        addBtn.disabled = !value;
        addBtn.toggleAttribute("aria-disabled", !value);
      };

      setState();
      form.addEventListener("change", setState);
      form.addEventListener("input", setState);

      const obs = new MutationObserver(() => setState());
      obs.observe(idInput, { attributes: true, attributeFilter: ["value"] });
    });
  };

  document.addEventListener("DOMContentLoaded", init);
  document.addEventListener("shopify:section:load", init);
})();
